export default {
      id: "star-usage",
      viewBox: "0 0 30 29",
      url: __webpack_public_path__ + "sprite-46b249.svg#star-usage",
      toString: function () {
        return this.url;
      }
    }